// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"716":"7c67f175","787":"fc157bfd"}[chunkId] + ".chunk.js";
};